import { SemanticModel, Table, Schema } from "@pufflig/prompt-studio-types";
import { useSemanticModelStore } from "../SemanticModelProvider";

export const reconcileSemanticModel = () => {
  const { semanticModel, dbSchema } = useSemanticModelStore.getState();
  if (!dbSchema) return;

  // initialize semantic model if it doesn't exist
  let newSemanticModel: SemanticModel = semanticModel || {
    name: dbSchema.name,
    description: dbSchema.description,
    connectors: dbSchema.connectors || [],
    schemas: {},
  };

  // remove schemas not present in db schema
  Object.keys(newSemanticModel.schemas).forEach((schemaName) => {
    if (!dbSchema.schemas?.[schemaName]) {
      delete newSemanticModel.schemas[schemaName];
    }
  });

  // iterate through schemas from db
  Object.entries(dbSchema.schemas || {}).forEach(([schemaName, schema]) => {
    const existingSchema: Schema = newSemanticModel.schemas[schemaName] || {
      tables: {},
      schemaDescription: schema.schemaDescription,
    };

    // remove tables that no longer exist
    Object.keys(existingSchema.tables || {}).forEach((tableName) => {
      if (!schema.tables?.[tableName] && !schema.views?.[tableName]) {
        delete existingSchema.tables[tableName];
      }
    });

    // add new tables
    Object.entries({ ...(schema.tables || {}), ...(schema.views || {}) }).forEach(([tableName, table]) => {
      if (!existingSchema.tables[tableName]) {
        existingSchema.tables[tableName] = { ...(table as Table) };
      }
    });

    // update schema description if changed
    existingSchema.schemaDescription = existingSchema.schemaDescription || schema.schemaDescription;

    newSemanticModel.schemas[schemaName] = existingSchema;
  });

  useSemanticModelStore.setState(
    (state) => {
      state.semanticModel = newSemanticModel;
    },
    false,
    "semantic/reconcile_semantic_model",
  );

  return newSemanticModel;
};
